import { create } from 'zustand';

import { EpisodePurchaseType } from '@constants';

export type AutoPurchaseType =
  | EpisodePurchaseType.rental
  | EpisodePurchaseType.possession
  | EpisodePurchaseType.storyPass;

type AutoPurchaseStore = {
  autoPurchase?: {
    storyId: number;
    purchaseType: AutoPurchaseType;
    isAutoApplyVoucher: boolean;
  };
  setAutoPurchase: (
    storyId: number,
    purchaseType: AutoPurchaseType,
    isAutoApplyVoucher?: boolean
  ) => void;
  reset: () => void;
};

export const useAutoPurchaseStore = create<AutoPurchaseStore>((set) => ({
  autoPurchase: undefined,
  setAutoPurchase: (storyId, purchaseType, isAutoApplyVoucher = false) => {
    set({
      autoPurchase: {
        storyId,
        purchaseType,
        isAutoApplyVoucher,
      },
    });
  },
  reset: () => {
    set({ autoPurchase: undefined });
  },
}));
